export const SHOW_SIDEBAR = 'SHOW_SIDEBAR';
export const MINIMIZE_SIDEBAR = 'MINIMIZE_SIDEBAR';
export const SHOW_ASIDE = 'SHOW_ASIDE';
export const ENABLE_DARKMODE = 'TOGGLE_DARKMODE';
